<div layout-vertical>
  <rt-redactor-inserts-dropdown-header
    [hasBackAction]="hasBackAction"
    [label]="'app.redactor_inserts.integrations_kununu.dropdown.heading' | translate"
    (goBack)="back.emit()"
    (closeDropdown)="closeDropdown.emit()"
  >
  </rt-redactor-inserts-dropdown-header>

  <rt-dropdown-item (click)="insertApplicantFeedback()">
    {{ 'app.redactor_inserts.integrations_kununu.dropdown.applicant_feedback' | translate }}
  </rt-dropdown-item>

  <rt-dropdown-item (click)="insertEmployeeFeedback()">
    {{ 'app.redactor_inserts.integrations_kununu.dropdown.employee_feedback' | translate }}
  </rt-dropdown-item>
</div>
